module.exports = __webpack_public_path__ + "static/media/IMG-1.8338997a.jpg";